import { Select } from "antd";
import React from "react";

function SelectInput({ label, value, placeholder, onChange, options, errors, style, disabled }) {
  return (
    <div className="input-box">
      <label>{label}</label>
      <Select
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        style={style}
        onChange={onChange}
        options={options}
      />
      {errors && <span style={{ color: "red" }}>{errors}</span>}
    </div>
  );
}

export default SelectInput;
